import { MAT_LEGACY_DIALOG_DATA as MAT_DIALOG_DATA, MatLegacyDialogRef as MatDialogRef } from '@angular/material/legacy-dialog';
import {AfterViewInit, Component, Inject, OnInit} from '@angular/core';
import {UsersService} from '../../../shared/services/users.service';
import {Principal} from '../../../core/auth/principal.service';
import {GlobalSpinnerService} from '../../../core/services/global-spinner.service';
import {SnackBarService} from '../../../core/services/snackbar.service';
import {ServerErrorUtils} from '../../../shared/utils/server-error-utils';
import {User} from '../../../core/auth/user.model';
import {UserRole, UserRoleKL} from '../../../core/auth/user-role.model';
import {Publisher, PublisherStatus} from '../../../shared/domain/publisher.model';
import {ContentOwnerService} from '../../../shared/services/content-owner.service';
import { ActivatedRoute } from '@angular/router';
import { Subject } from 'rxjs';
import { RolePermission } from 'src/app/core/auth/rbac/role-permission.service';
import { PrincipalUtils } from 'src/app/core/auth/principal.utils';

@Component({
  selector: 'ctv-user-editor-dialog',
  templateUrl: './user-editor-dialog.component.html',
})
export class UserEditorDialogComponent implements OnInit, AfterViewInit {
  public readonly RolePermission = RolePermission;
  isEdit: boolean;
  user = new User();
  userRoleKL = UserRoleKL();
  userRole = UserRole;
  publisherStatuses = [PublisherStatus.ACTIVE];
  userType: {type: 'co' | 'publisher'; id: string};
  disabled = false;
  networkId: string;
  eventsSubjectNetwork = new Subject<string[]>();
  clearFilterItems: Subject<void> = new Subject<void>();

  constructor(public dialogRef: MatDialogRef<UserEditorDialogComponent>,
              private service: UsersService,
              private principal: Principal,
              private route: ActivatedRoute,
              private gss: GlobalSpinnerService,
              private snackBarService: SnackBarService,
              private coService: ContentOwnerService,
              @Inject(MAT_DIALOG_DATA) public data: any) {
    this.user = new User();
    if (data && data.userType) {
      this.userType = data.userType;
      this.userType.type === 'co' ? this.user.contentOwnerIds = [this.userType.id] : this.user.publisherIds = [this.userType.id];
      if (this.userType.type === 'co') {
        this.getContentOwnerDetail();
      }
      this.user.roles = [this.userType.type && this.userType.type === 'co' ? this.userRole.CONTENT_OWNER : this.userRole.PUBLISHER];
      this.disabled = true;
    }
    if (data && data.user) {
      this.isEdit = !!data.user;
      this.user = data.user;
    }
    if (data && data.publisherId) {
      this.user.publisherIds = data.publisherId ? [data.publisherId] : [];
    }

    if (data && data.networkId) {
      this.networkId = data.networkId;
      this.eventsSubjectNetwork.next([this.networkId]);
    }
  }

  ngOnInit(): void {
    if (this.networkId) {
      this.userRoleKL = this.userRoleKL.filter(item => ![UserRole.CONTENT_OWNER, UserRole.READ_ONLY_ADMIN, UserRole.CAMPAIGN_MANAGER, UserRole.REV_OPS].includes(item.key));
    }
  }

  ngAfterViewInit(): void {
    this.dialogRef.updateSize('500px');
  }

  isPublisher(){
    return this.user.roles && (this.user.roles.includes(this.userRole.PUBLISHER));
  }

  createUser() {
    this.gss.showLoader();
    this.user.name = this.user.name?.trim();
    this.user.email = this.user.email?.trim();

    if (!this.user.roles) {
      this.user.roles = [];
    }

    if (!(this.user.roles.includes(UserRole.PUBLISHER) || this.user.roles.includes(UserRole.SALES_REPRESENTATIVE))) {
      this.user.publisherIds = [];
    }
    if (!this.user.roles.includes(UserRole.CONTENT_OWNER)) {
      this.user.contentOwnerIds = [];
    }
    if (this.isEdit) {
      this.service.update(this.user).subscribe(next => {
          this.gss.hideLoader();
          this.dialogRef.close(true);
          this.snackBarService.success('User updated successfully');
        },
        (e) => {
          const messages = ServerErrorUtils.getValidationMessages(e);
          if (messages) {
            messages.forEach(m => this.snackBarService.error(m));
          } else {
            this.snackBarService.error('Error occurred during user creation');
          }
          this.gss.hideLoader();
        }
      );
    } else {
      if (this.networkId) {
        this.createNetworkUser();
      } else {
        this.createNormalUser();
      }
    }
  }

  createNetworkUser() {
    this.service.createNetwork(this.user, this.networkId).subscribe(next => {
      this.gss.hideLoader();
      this.dialogRef.close(true);
      this.snackBarService.success('User created successfully');
    },
    (e) => {
      const messages = ServerErrorUtils.getValidationMessages(e);
      if (messages) {
        messages.forEach(m => this.snackBarService.error(m));
      } else {
        this.snackBarService.error('Error occurred during user creation');
      }
      this.gss.hideLoader();
    }
    );
  }

  createNormalUser() {
    this.service.create(this.user).subscribe(next => {
      this.gss.hideLoader();
      this.dialogRef.close(true);
      this.snackBarService.success('User created successfully');
    },
    (e) => {
      const messages = ServerErrorUtils.getValidationMessages(e);
      if (messages) {
        messages.forEach(m => this.snackBarService.error(m));
      } else {
        this.snackBarService.error('Error occurred during user creation');
      }
      this.gss.hideLoader();
    }
    );
  }

  onPublisherSelection(pubs: Publisher[]) {
    this.user.publisherIds = pubs.map(p => p.id);
  }

  onContentOwnerSelection(contentOwnerIds: string[]) {
    this.user.contentOwnerIds = contentOwnerIds;
  }

  getContentOwnerDetail() {
    this.coService.getCoDetails(this.userType.id).subscribe(
      response => {
        this.user.contentOwners = [response];
      },
      error => {
        ServerErrorUtils.serverValidationOrMsg(error, this.snackBarService, 'Error occurred fetching content owner');
      }
    );
  }

  moreThanOneMainRoleSelected(): boolean {
    return PrincipalUtils.hasMoreThanOneMainRole(this.user);
  }
}
